import { render } from "./CompareLabel.vue?vue&type=template&id=ffa8d01e"
import script from "./CompareLabel.vue?vue&type=script&lang=js"
export * from "./CompareLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__